import { call, put, takeEvery } from "redux-saga/effects";
import {GET_RIDE_DETAILS, } from "resources/actionTypes";
import { rideDetailsApi } from "services/DashboardService";

function* fetchRideDetails(action) {
  try {
    const payload = action.payload || {}
    const userRideDetails = yield call(rideDetailsApi, payload);
    yield put({ type: GET_RIDE_DETAILS.GET_RIDE_DETAILS_SUCCESS, userRideDetails: userRideDetails });
  } catch (e) {
    yield put({ type: GET_RIDE_DETAILS.GET_RIDE_DETAILS_FAILED, message: e.message });
  }
}

export function* userRideDetailsSaga() {
  yield takeEvery(GET_RIDE_DETAILS.GET_RIDE_DETAILS_REQUESTED, fetchRideDetails);
}